import styled from '@emotion/styled'
import Breadcrumb from '../../../components/common/Breadcrumb'
import Card from '../../../components/common/Card'
import iconUser from '../../../assets/images/icons-user-green-32-px.svg'
import iconUserGroup from '../../../assets/images/icons-user-group-green-32-px.svg'
import iconChange from '../../../assets/images/icons-change-green-24-px.svg'
import Text from '../../../components/common/Text'
import Welfare from './Welfare'
import FooterContent from '../../../components/FooterContent'
import { useScreen } from '../../../utils/responsive-helper'
import Button from '../../../components/common/Button'
import { useCallback } from 'react'
import * as paths from '../../../constant/path'
import { useHistory } from 'react-router'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useGetEnrollmentPeriod } from '../../../services/enrollment/enrollment-query'
import { convertDateFormatTH, DateFormat } from '../../../utils/dateFormat'
import PointCard from '../../../components/PointCard'
import { useGetEnrollmentYear } from '..'

const Layout = styled.div`
  > * {
    margin-top: 24px;
  }
  text-align: center;
`

const ButtonStyle = styled(Button)`
  width: 267px;
`

const Header = styled.div`
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 24px;
`

const HeaderYear = styled.div`
  text-align: start;
  margin-bottom: 14px;
`

const CustomStyleCard = styled(Card)`
  display: flex;
  /* position: relative; */
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`

const LayoutBodyWelware = styled.div`
  text-align: start;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;
`

const EnrollmentDetail = () => {
  const { t } = useTranslation()
  const screen = useScreen()
  const history = useHistory()
  const { enrollmentYear } = useGetEnrollmentYear()

  const { data: enrollmentPeriod } = useGetEnrollmentPeriod()
  const startDate = convertDateFormatTH(
    dayjs(enrollmentPeriod?.startDate).toDate(),
    DateFormat.FORMAT_1TH,
  )
  const endDate = convertDateFormatTH(
    dayjs(enrollmentPeriod?.endDate).toDate(),
    DateFormat.FORMAT_1TH,
  )

  const { isMobile } = screen

  const getBenefits = useCallback(() => {
    history.push(
      paths.benefits({
        routeParam: { benefitYearId: enrollmentPeriod?.benefitYearId || 1 },
      }),
    )
  }, [enrollmentPeriod?.benefitYearId, history])

  return (
    <Layout>
      {!isMobile && (
        <Breadcrumb
          overide={(paths) => {
            paths[0].label = t('ปรับเปลี่ยนสวัสดิการ')
            paths[1].label = t(`ดูสวัสดิการปี ${enrollmentYear}`)
            return paths
          }}
        />
      )}
      <Header>
        <Text size={28} type="Bold">
          วางแผนสวัสดิการยืดหยุ่นประจำปี {enrollmentYear} ได้ตั้งแต่วันที่ {startDate} - {endDate}
        </Text>
      </Header>
      <HeaderYear>
        <Text size={26} type="Bold">
          คะแนนของปี {enrollmentYear}
        </Text>
      </HeaderYear>
      <PointCard />
      <Text size={20} style={{ textAlign: 'start' }}>
        คุณสามารถใช้คะแนนมากกว่าคะแนนตั้งต้นได้ โดยบริษัทจะหักคะแนนส่วนต่างจากเงินเดือน
        ปกติวันลาจะถูก Auto Convert เป็น Flow Point
      </Text>
      <Text size={26} type="Bold" style={{ textAlign: 'start' }}>
        สวัสดิการบริษัทที่สามารถปรับเปลี่ยนได้
      </Text>
      <CustomStyleCard>
        <LayoutBodyWelware>
          {/* <Welfare iconPath={iconUser} title={'ประกันของตัวเอง '} descriptions={[]}></Welfare>
          <Welfare
            iconPath={iconUserGroup}
            title={'ประกันเพิ่มเติม ให้ครอบครัว'}
            descriptions={[
              'สำหรับ คู่สมรส บุตร บิดา มารดา เท่านั้น',
              'ต้องส่งเอกสารแสดงความสัมพันธ์ให้กับ HR ตรวจสอบด้วย',
            ]}
          ></Welfare> */}
          <Welfare
            iconPath={iconChange}
            title={'สวัสดิการอื่นๆ'}
            descriptions={[
              // 'แลกเปลี่ยนวันลา',
              'สวัสดิการยืดหยุ่น',
            ]}
          ></Welfare>
        </LayoutBodyWelware>
      </CustomStyleCard>
      <FooterContent
        style={{
          height: 80,
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-end',
          alignItems: 'center',
        }}
      >
        {<ButtonStyle onClick={getBenefits}>ถัดไป</ButtonStyle>}
      </FooterContent>
    </Layout>
  )
}

export default EnrollmentDetail
